export const selectAppUI = state => state.appUI;
export const selectIsMobileLook = state => state.appUI.isMobileLook;
export const selectIsDebugMode = state => state.appUI.isDebugMode;
export const selectNativeUXVersion = state => state.appUI.nativeUXVersion;
